import React from "react";
import { languages } from "../../constants/languages";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Radio from "@material-ui/core/Radio";
import TextField from "@material-ui/core/TextField";
import Chip from "@material-ui/core/Chip";
import { Typography } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";

export const CreateFeatureDialog = props => (
  <div>
    <Dialog open={props.open}>
      <DialogTitle
        id="form-dialog-title"
        style={{
          borderBottom: "1px solid gray",
          padding: "20px 24px 12px 18px"
        }}
      >
        <IconButton
          color="inherit"
          onClick={props.toggleDialog}
          aria-label="Close"
          style={{ marginRight: 10 }}
        >
          <CloseIcon />
        </IconButton>
        {languages.features.create}
        <div
          style={{
            display: "inline",
            float: "right",
            fontSize: 14,
            paddingTop: 10,
            fontWeight: "normal"
          }}
        >
          {languages.features.step +
            " " +
            (props.step + 1).toString() +
            " " +
            languages.features.of +
            " 4"}
        </div>
      </DialogTitle>
      <DialogContent style={{ width: 800, maxWidth: "97%", paddingTop: 25 }}>
        <DialogContentText />
        {/* STEP 1 */}
        {props.step === 0 && (
          <div>
            {languages.features.howDoYouUse}
            <br />
            <br />
            <Radio
              color="primary"
              name="useType"
              value="0"
              checked={props.useType === "0"}
              onChange={props.handleChange}
            />{" "}
            {languages.features.iAmOrganizer}
            <br />
            <Radio
              color="primary"
              name="useType"
              value="1"
              checked={props.useType === "1"}
              onChange={props.handleChange}
            />{" "}
            {languages.features.iAmTeam}
            <br />
            <Radio
              color="primary"
              name="useType"
              value="2"
              checked={props.useType === "2"}
              onChange={props.handleChange}
            />{" "}
            {languages.features.iAmSupporter}
          </div>
        )}
        {/* STEP 2 */}
        {props.step === 1 && (
          <div>
            {languages.features.whatWouldYouLikeToSee}
            <br />
            {languages.getLanguage() !== "nl" &&
              languages.getLanguage() !== "en" && (
                <Typography
                  style={{
                    background: "rgb(236, 239, 241)",
                    padding: 10,
                    borderRadius: 5,
                    marginTop: 10
                  }}
                >
                  <InfoIcon style={{ height: 15, width: 15 }} />
                  {" Please write your idea in English"}
                </Typography>
              )}
            <br />
            <TextField
              variant="outlined"
              multiline
              rows="2"
              fullWidth
              name="what"
              value={props.what}
              onChange={props.handleWhatChange}
            />
          </div>
        )}
        {/* STEP 3 */}
        {props.step === 2 && (
          <div>
            {languages.features.whyDoYouWant + " " + props.whatSliced + "?"}
            <br />
            {languages.getLanguage() !== "nl" &&
              languages.getLanguage() !== "en" && (
                <Typography
                  style={{
                    background: "rgb(236, 239, 241)",
                    padding: 10,
                    borderRadius: 5,
                    marginTop: 10
                  }}
                >
                  <InfoIcon style={{ height: 15, width: 15 }} />
                  {" Please write your idea in English"}
                </Typography>
              )}
            <br />
            <TextField
              variant="outlined"
              multiline
              rows="2"
              fullWidth
              name="why"
              value={props.why}
              onChange={props.handleWhyChange}
            />
          </div>
        )}
        {/* STEP 4 */}
        {props.step === 3 && (
          <div>
            {languages.features.checkYourIdea}
            <br />
            <br />
            <div style={{ fontWeight: 500, fontSize: 24 }}>
              {props.ideaString}
            </div>
            <br />
            {Object.keys(languages.features.categories).map((key, i) => {
              return (
                <Chip
                  key={key}
                  size="small"
                  style={{ margin: 5 }}
                  color={props.category === key ? "primary" : "default"}
                  name="category"
                  onClick={e => {
                    props.handleCategoryClick(e, key);
                  }}
                  label={languages.features.categories[key]}
                />
              );
            })}
          </div>
        )}
      </DialogContent>

      <DialogActions>
        {props.step > 0 && (
          <Button onClick={props.handleBack}>
            {languages.features.stepBack}
          </Button>
        )}
        {props.step < 4 && (
          <Button variant="outlined" color="default" onClick={props.handleNext}>
            {props.step === 3
              ? languages.features.submitIdea
              : languages.features.toStep + " " + (props.step + 2).toString()}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  </div>
);
